export default [
	{
		start: 0.05,
		end: 2,
		text: 'Ça ne s\'arrêtera donc jamais ?'
	}
]
